import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'ol/ol.css';
import apply from 'ol-mapbox-style';
import { LineString, Polygon } from 'ol/geom';
import Map from 'ol/Map';
import View from 'ol/View';
import Hash from './hash';
import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT';

import VectorSource from 'ol/source/Vector';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { fromLonLat, get as projGet } from 'ol/proj'

import { clear, div, htmlEl, table } from './ui';
import { webLang, normalizedLang, texts, applyLocale, getLocalizationGroup } from './locale';
import TileGrid from 'ol/tilegrid/TileGrid';
import { getArea, getLength } from 'ol/sphere'

import TileLayer from 'ol/layer/Tile';

import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import WMSCapabilities from 'ol/format/WMSCapabilities.js';
import ImageWMS from 'ol/source/ImageWMS';
import { Image as ImageLayer } from 'ol/layer';
import TileWMS from 'ol/source/TileWMS';


proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");
proj4.defs("EPSG:3067", "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
register(proj4);



const params = (new URL(document.location)).searchParams,
  lang = normalizedLang[params.get('lang')] || 'fin';

document.lang = webLang[lang];
const locale = texts[lang];

const wmtsUrl = 'https://karttamoottori.maanmittauslaitos.fi/maasto/wmts/1.0.0/WMTSCapabilities.xml',
  wmsUrl = 'https://avoin-visukuva.nls.fi/visukuvatu05/sopimus/service/ows?request=GetCapabilities';


const mapOpts = {
  dataProj: 'EPSG:3067',
  viewProj: 'EPSG:3067',
  dataCrs: 'http://www.opengis.net/def/crs/EPSG/0/3067',
  tileGridSet: 'ETRS-TM35FIN',
  featuresMinZoom: 11,
  styleFuncOptions: {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25, 0.125]
  },
  projection: projGet('EPSG:3067'),
  extent: [-548576, 6291456, 1548576, 8388608],
  adjustZ: 3
};


mapOpts.projection.setExtent(mapOpts.extent);

const WMSParser = new WMSCapabilities();

const WMTSparser = new WMTSCapabilities();

const tileLayersMap = {
  btns: {},
  arr: [],
  map: {},
  ids: [],
  locale: {}
};

await fetch(wmtsUrl)
  .then(function (response) {
    return response.text();
  })
  .then(function (text) {
    const result = WMTSparser.read(text);

    const WMTSlayers = result.Contents.Layer;
    WMTSlayers.forEach(l => {
      const options = optionsFromCapabilities(result, {
        layer: l.Identifier,
        matrixSet: mapOpts.tileGridSet,
        projection: mapOpts.viewProj,
        requestEncoding: 'REST'

      });
      let layer = new TileLayer({
        opacity: 1,
        source: new WMTS(options),
        visible: false
      })

      let layerId = `wmts_${l.Identifier}`;

      tileLayersMap.arr.push(layer);
      tileLayersMap.ids.push(layerId);
      tileLayersMap.map[layerId] = layer;
      tileLayersMap.locale[layerId] = `WMTS ${l.Identifier}`;

    });
    return tileLayersMap;

  });

await fetch(wmsUrl)
  .then((response) => {
    return response.text();
  }).then((text) => {
    const result = WMSParser.read(text);

    const WMSLayers = result.Capability.Layer.Layer;
    const WMSUrl = result.Service.OnlineResource;

    WMSLayers.forEach(l => {

      let layer = new TileLayer({
        visible: false,
        source: new TileWMS({
          url: WMSUrl,
          params: {'LAYERS': l.Name, 'TILED': true},
          transition: 0
        }),
      });

      let layerId = `wms_${l.Name}`;

      tileLayersMap.arr.push(layer);
      tileLayersMap.ids.push(layerId);
      tileLayersMap.map[layerId] = layer;
      tileLayersMap.locale[layerId] = `WMS ${l.Title||l.Name}`;

    });

  });

window.tileLayersMap = tileLayersMap;

const tileGrid = new TileGrid({
  extent: mapOpts.extent,
  resolutions: mapOpts.styleFuncOptions.resolutions,
  tileSize: [256, 256]
})



const wkt = new WKT();

const
  apiKey = '7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2',
  apiVer = 'v3',
  apiVerUrl = `https://avoin-paikkatieto.maanmittauslaitos.fi/kiinteisto-avoin/simple-features/${apiVer}`;


const batchSize = 1000;

let colls = [],
  collsByFeatTypeMap = {};


let currentSelection = {
  bounds: undefined,
  geom: undefined
};

let state = 'navigation_p1';


applyLocale(locale);

let center = [476143, 6945745];

const hash = new Hash(undefined, mapOpts.adjustZ),
  map = new Map({
    target: 'map',
    view: new View({
      resolution: 256,
      resolutions: mapOpts.styleFuncOptions.resolutions,
      center: center,
      projection: mapOpts.projection
    }),
    layers: [
    ]
  }),
  format = new GeoJSON({
    featureProjection: mapOpts.viewProj,
    dataProjection: mapOpts.dataProj
  });
hash.addTo(map);
window.map = map;
applyBgLayers(map, tileLayersMap);
applyBgSelections(map, tileLayersMap);
applyBgSelectionToMap(map, tileLayersMap.ids[0], true);
applyButtons(map);

var mapSelectionSource = new VectorSource({});
let selTools = {

};


function applyBgLayers(map, tileLayersMap) {
  tileLayersMap.arr.forEach(l => {
    map.addLayer(l);
  });
}

function applyBgSelections(map, tileLayersMap) {
  const ids = tileLayersMap.ids;
  const bgSelEl = document.getElementById('bgSelections');

  const
    bglocales = getLocalizationGroup(locale, 'bg');

  ids.forEach(bg => {

    const divEl = div(bgSelEl),
      inputEl = htmlEl(divEl, 'input', 'form-check-input'),
      labelEl = htmlEl(divEl, 'label', 'form-check-label');

    divEl.classList.add('form-check');
    divEl.classList.add('form-switch');
    inputEl.setAttribute('id', bg);
    inputEl.setAttribute('type', 'checkbox');
    inputEl.setAttribute('data-bg', bg);
    //inputEl.setAttribute('checked', 'checked');
    labelEl.setAttribute('for', bg);
    labelEl.innerText = bglocales[bg] || tileLayersMap.locale[bg] || bg;

    inputEl.onchange = (evt) => {
      const evtTgtEl = evt.target,
        evtTgtBg = evtTgtEl.dataset.bg,
        evtTgtBgSel = evtTgtEl.checked;

      console.log("CHANGE", evtTgtBg, evtTgtBgSel);

      applyBgSelectionToMap(map, evtTgtBg, evtTgtBgSel);
    };

    tileLayersMap.btns[bg] = inputEl;
  });


}


function applyButtons(map) {


  const cancelbutton = document.getElementById('cancel');
  cancelbutton.onclick = () => {
    const el = document.getElementById('info');
    clear(el);
    applyState('navigation_p2');
    clearSelections(map);
  }

}

function clearSelections(map) {

  tileLayersMap.ids.forEach(lid => {
    tileLayersMap.map[lid].setVisible(false);
    tileLayersMap.btns[lid].checked = false;
  });

}


function applyBgSelectionToMap(map, bg, bgSel) {
  console.log(map, bg, bgSel);

  if (bgSel) {

    for (const [key, value] of Object.entries(tileLayersMap.btns)) {
      //console.log(`${key}: ${value}`);
      tileLayersMap.map[key].setVisible(false);
      value.checked = false;
    }

    tileLayersMap.map[bg].setVisible(bgSel);
    tileLayersMap.btns[bg].checked = true;
  } else {
    tileLayersMap.map[bg].setVisible(bgSel);
    tileLayersMap.btns[bg].checked = false;
  }


}



function applyState(s) {

  state = s;
  const el = document.getElementById('state');

  el.innerText = locale.state[state];


}


